import React from "react";
import { Link } from "react-router-dom";
import { IconBrandLinkedin } from "@tabler/icons-react";

const Footer = () => {
  return (
<footer className="w-full bg-[#4b534e] dark:bg-[#1c1c1c] text-white py-6 mt-6"> 
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-0">

        {/* Brand / Logo Section */}
        <div className="flex items-center gap-4">
          <img src="/assets/kuralogo.svg" alt="Kura Digital Logo" className="h-12 w-auto" />
          <h3 className="text-xl font-bold">Kura Digital</h3>
        </div>

        {/* Navigation Links (Reduced Padding for Compactness) */}
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <Link to="/services/websites" className="hover:text-gray-300 transition">Websites</Link>
          <Link to="/services/software" className="hover:text-gray-300 transition">Software</Link>
          <Link to="/services/maintenance" className="hover:text-gray-300 transition">Maintenance</Link>
          <Link to="/faq" className="hover:text-gray-300 transition">FAQ</Link>
          <Link to="/our-process" className="hover:text-gray-300 transition">Our Process</Link>
          <Link to="/contact" className="hover:text-gray-300 transition">Contact</Link>
        </div>

        {/* Social Media Links (Kept Small & Inline) */}
        <div className="flex items-center gap-4">
          <a href="https://linkedin.com/in/kura-digital" target="_blank" rel="noopener noreferrer">
            <IconBrandLinkedin className="w-5 h-5 text-gray-300 hover:text-white transition" />
          </a>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="mt-4 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} Kura Digital. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;

